class UFilteredListFilters extends Uneet {
  constructor (domElement, toggleCallback, filterUpdateCallback, dateFilterUpdateCallback) {
    super(domElement)
    this.filters = []
    this.dateFilter = null
    this.isShowingDateFilter = false
    this.__toggleCallback = toggleCallback
    this.__filterUpdateCallback = this.__debounce(filterUpdateCallback, 100)
    this.__dateFilterUpdateCallback = dateFilterUpdateCallback
    this.__init()
  }

  __init () {
    // init filters and pass the callback
    this._e.querySelectorAll('.u_filtered-list-filter').forEach((filterDOMElement) => {
      const filter = new UFilteredListFilter(
        filterDOMElement,
        this.__noop,
        (alteredFilter, alteredFilterItem) => {
          this.__filterUpdateCallback(alteredFilter, alteredFilterItem)
        })
      this.filters.push(filter)
    })

    // init date filter and pass the cb
    this.dateFilter = new UFilteredListDateFilter(
      this._e.querySelectorAll('.u_filtered-list-date-filter')[0],
      this.__noop,
      (dateFilter, prevYear) => {
        this.__dateFilterUpdateCallback(dateFilter, prevYear)
      })

    // bind reset btn
    this._e.querySelectorAll('button.reset-btn')[0].onClick((ev) => {
      this.filters.forEach((filter) => {
        filter.deactivateAllFilterItems()
      })
      this.dateFilter.resetDateFilter()
      this.__toggleCallback(ev)
    })

    // bind the apply btn
    this._e.querySelectorAll('button.close-btn')[0].onClick((ev) => {
      this.__toggleCallback(ev)
    })
  }

  getActiveFilterCount () {
    const activeFilters = this.getActiveFilters()
    let count = 0
    if (activeFilters) {
      Object.keys(activeFilters).forEach((key) => {
        count += activeFilters[key].length
      })
    }
    count += (this.getDateFilter() !== null) ? 1 : 0
    return count
  }

  // returns all filters (for checkup on selectedFilters component)
  getAllFiltersForSelectedFilters () {
    const retArray = []
    this.filters.forEach((filter) => {
      const filterItems = filter.getFilterItemsForSelectedFilters()
      filterItems.forEach((filterItem) => {
        retArray.push(filterItem)
      })
    })
    const dateObj = ((dFilter) => {
      const dId = (dFilter) || 0
      const dLabel = (dFilter) || 'all'
      const dIsActive = !!(dFilter)
      return {
        token: 'date',
        id: dId,
        label: 'Year: ' + dLabel,
        isActive: dIsActive,
        turnOffFunction: () => {
          this.dateFilter.toggle(false)
        }
      }
    })(this.dateFilter.getDateFilter())
    retArray.push(dateObj)
    return retArray
  }

  getActiveFilters () {
    let activeFilters = null
    this.filters.forEach((filter) => {
      filter.getActiveFilterItems().forEach((filterItem) => {
        if (activeFilters === null) {
          activeFilters = {}
        }
        if (activeFilters[filter.filtertoken] === undefined) {
          activeFilters[filter.filtertoken] = []
        }
        activeFilters[filter.filtertoken].push(filterItem.id)
      })
    })
    return activeFilters
  }

  getDateFilter () {
    return this.dateFilter.getDateFilter()
  }

  toggleDateFilter (force = null) {
    if (force !== null) {
      this.isShowingDateFilter = !this.isShowingDateFilter
    } else {
      this.isShowingDateFilter = force
    }
    this._e.toggleClass('isShowingDateFilter', this.isShowingDateFilter)
  }

  clearAll () {
    this.filters.forEach((filter) => {
      filter.deactivateAllFilterItems()
    })
    this.dateFilter.resetDateFilter()
  }
}
